module.exports = __webpack_public_path__ + "media/images/about-us-img-04-2c8c379f1fc33a99a1f66d48d44337f4.jpg";